import angular from 'angular';

class BusquedaController {

	constructor($scope, $stateParams, $log, $state, $sce, $filter, buscadorService, utilFactory, paginacionConfig, sugerenciaConfig, moment, tipoBusquedaConfig, tipoRegistroConfig, urlConfig, campoBusquedaConfig) {

		this.moment = moment;
		this.$stateParams = $stateParams;
		this.$scope = $scope;
		this.$log = $log;
		this.$state = $state;
		this.$sce = $sce;
		this.$filter = $filter;
		this.buscadorService = buscadorService;
		this.utilFactory = utilFactory;
		this.paginacionConfig = paginacionConfig;
		this.sugerenciaConfig = sugerenciaConfig;
		this.esFiltroMobileContraido = true;
		this.esMasFiltroContraido = true;
		this.limiteOrganismo = this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;
		this.limiteCargo = this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;
		this.limiteTipoRegistro = this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;
		this.limiteAutores = this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;
		this.limiteOrigenes = this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;
		this.limiteRegion = this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;

		this.tipoBusquedaConfig = tipoBusquedaConfig;
		this.tipoRegistroConfig = tipoRegistroConfig;
		this.urlConfig = urlConfig;

		this.orden = [
			{ id: 1, campo: 'score', despliegue: 'Relevancia', descendente: true },
			//{ id: 2, campo: 'fechaInicio', despliegue: 'Más Reciente', descendente: true },
			//{ id: 3, campo: 'fechaInicio', despliegue: 'Menos Reciente', descendente: false },
			//{ id: 4, campo: 'nombrePasivo', despliegue: 'Nombre', descendente: true },
			{ id: 2, campo: 'cargo', despliegue: 'Cargo', descendente: false },
			{ id: 3, campo: 'organismo', despliegue: 'Organismo', descendente: false }
		];

		this.modelo = {
			Busqueda: {
				TextoBusqueda: this.$stateParams.TextoBusqueda,
				BusquedaExacta: false,
				Facetas: [],
				CamposBusqueda: [],
				FechaDesde: null,
				FechaHasta: null,
				CostoDesde: null,
				CostoHasta: null,
				Nombre: null,
				Pagina: 1,
				Registros: this.paginacionConfig.CANTIDAD_REGISTROS,
				MaximoPaginas: this.paginacionConfig.MAXIMO_PAGINAS,
				Orden: 1

			},
			ResultadoBusqueda: {
				Documentos: [],
				TotalEncontrados: 0,
				Busqueda: null,
				Destacados: [],
				Organismos: [],
				Cargos: [],
				TiposRegistro: [],
				Funcionarios: [],
				Regiones: [],
				Facetas: {
					CantSujetoPasivo: 0,
					CantSujetoPasivoStr: 0,
					CantAudiencia: 0,
					CantAudienciaStr: 0,
					CantDonativo: 0,
					CantDonativoStr: 0,
					CantViaje: 0,
					CantViajeStr: 0,
					CantSujetoActivo: 0,
					CantSujetoActivoStr: 0,
					CantRepresentado: 0,
					CantRepresentadoStr: 0,
					CantOrganismo: 0,
					CantOrganismoStr: 0,
					CantCaso: 0,
					CantCasoStr: 0,
					CantOrdenCompra: 0,
					CantOrdenCompraStr: 0,
					CantLicitacion: 0,
					CantLicitacionStr: 0,
					CantProveedor: 0,
					CantProveedorStr: 0
				},
				TotalEncontradosStr: 0,
				CamposBusqueda: [],
			},

			/* Campos de búsqueda segmentados por tipo de registro */
			camposBusquedaSegmentados: {
				SujetoActivo: [
					campoBusquedaConfig.NOMBRE_ACTIVO,
					campoBusquedaConfig.TRABAJA_PARA,
					campoBusquedaConfig.NOMBRE_REPRESENTADO
				],
				Representado: [
					campoBusquedaConfig.NOMBRE_REPRESENTADO
				],
				SujetoPasivo: [
					campoBusquedaConfig.NOMBRE_PASIVO,
					campoBusquedaConfig._ORGANISMO_,
					campoBusquedaConfig._CARGO_,
					campoBusquedaConfig._REGION_
				],
				Viaje: [
					campoBusquedaConfig._ORGANISMO_,
					campoBusquedaConfig.PROPOSITO,
					campoBusquedaConfig.DATO_FINANCISTA,
					campoBusquedaConfig.DESTINO,
					campoBusquedaConfig.NOMBRE_PASIVO,
					campoBusquedaConfig._CARGO_
				],
				Donativo: [
					campoBusquedaConfig.NOMBRE_DONANTE,
					campoBusquedaConfig._ORGANISMO_,
					campoBusquedaConfig.OCASION,
					campoBusquedaConfig.SINGULARIZACION,
					campoBusquedaConfig._CARGO_,
					campoBusquedaConfig._REGION_,
					campoBusquedaConfig.NOMBRE_PASIVO
				],
				Audiencia: [
					campoBusquedaConfig.NOMBRE_ASISTENTE,
					campoBusquedaConfig.MATERIA,
					campoBusquedaConfig._CARGO_,
					campoBusquedaConfig._REGION_,
					campoBusquedaConfig.LUGAR,
					campoBusquedaConfig.OBSERVACION,
					campoBusquedaConfig.NOMBRE_PASIVO,
					campoBusquedaConfig._ORGANISMO_,
					campoBusquedaConfig.NOMBRE_ACTIVO,
					campoBusquedaConfig.CALIDAD,
					campoBusquedaConfig.TRABAJA_PARA,
					campoBusquedaConfig.NOMBRE_REPRESENTADO
				]
			},

			/* Indica si se deben deplegar los filtros especiales (filtro solo para algunos tipos de registros) */
			desplegarFiltroEspecial: {
				Costo: false,
				FechaInicioTermino: false
			}

		};

		this.descBotonResultados = 'Todos';
		this.totalOcurrencias = 0;
		this.mostrarSugerencia = false;
		this.cantMax = 99;
		this.cantMaxStr = '99+';
		/*ACCIONES EN SUGERENCIAS*/
		this.configurarBusqueda = this.configurarBusqueda;
		//this.buscar = buscar;
		this.verTodosResultados = this.verTodosResultados;
		this.limpiarResultados = this.limpiarResultados;
		this.cerrarSugerencia = this.cerrarSugerencia;

		this.esFiltroMobileContraido = true;
		this.esMasFiltroContraido = true;

		this.filtroActivo = {
			Todos: true,
			SujetoActivo: false,
			Representado: false,
			Audiencia: false,
			SujetoPasivo: false,
			Viaje: false,
			Donativo: false,
			Materia: false,
			Destino: false,
			Singularizacion: false,
			Organismo: false,
			Caso: false,
			OrdenCompra: false,
			Licitacion: false,
			Proveedor: false,
		}

		/* Mantiene la acumulación de filtros seleccionados */
		this.filtros = [];
		this.camposBusqueda = [];

		this._facetasSeleccionadas = {
			facetas: []
		};
	}

	cargarCamposBusqueda() {

		var d = $onInit.defer();

		enumeradorFactory
			.listar({
				tipo: 'CampoBusqueda'
			},
				function (response) {

					this.camposBusqueda = this.utilFactory.ordenarColeccion(response.data, 'Nombre');
					this.utilFactory.agregarItemTodos(this.camposBusqueda, 'ID', 'Nombre');

					d.resolve();
				});

		return d.promise;
	}

	filtrar(seccion, elemento) {
		/** Oculta filtros en modo mobile */
		this.esFiltroMobileContraido = true;

		if (seccion && elemento && elemento.Estado === false)
			this.eliminarFiltro(seccion, elemento);
		else
			this._realizarBusqueda();
	}

	buscarEnter(event) {
		console.log("paso por buscar enter 1");
		if (!this.utilFactory.isNullOrEmpty(this.modelo.Busqueda.TextoBusqueda)) {
			if (event.which == 13) {
				this.buscarRedirect(false);
			}
		}
	};

	buscarEnterRedirect(event) {
		console.log("paso por buscar enter 2");
		if (!this.utilFactory.isNullOrEmpty(this.modelo.Busqueda.TextoBusqueda)) {
			if (event.which == 13) {
				this.buscarRedirect(false);
			}
		}
	};

	eliminarFiltro(seccion, elemento) {
		//console.info(seccion);
		//console.info(elemento);
		/** Elimina el filtro de la colección de facetas global */
		for (var i = 0; i < this._facetasSeleccionadas.facetas.length; i++) {

			var key = Object.keys(this._facetasSeleccionadas.facetas[i])[0];

			if (key === seccion && this._facetasSeleccionadas.facetas[i][key] === elemento.key) {
				this._facetasSeleccionadas.facetas.splice(i, 1);
				/* Desmarca checkbox */
				this.limpiarFiltro(seccion, elemento);
				/* Vuelve a ejecutar búsqueda */
				this._realizarBusqueda();

				return;
			}

		}
	}

	_eliminarFiltro(seccion, elemento) {

		/** Elimina el filtro de la colección de facetas global */
		for (var i = 0; i < this._facetasSeleccionadas.facetas.length; i++) {

			var key = Object.keys(this._facetasSeleccionadas.facetas[i])[0];

			if (key === seccion && this._facetasSeleccionadas.facetas[i][key] === elemento.key)
				this._facetasSeleccionadas.facetas.splice(i, 1);
			/* Desmarca checkbox */
			this._limpiarFiltro(this._facetasSeleccionadas.facetas[i]);

		}

		//for (var i = 0; i < this.filtros.length; i++) {
		//    if (this.filtros[i].elemento.key === elemento.key) {
		//        /* Desmarca checkbox */
		//        limpiarFiltro(this.filtros[i]);

		//        /* Elimina filtro del arreglo */
		//        this.filtros.splice(i, 1);

		//        /* Elimina filtros relacionados con el filtro en curso */
		//        //var cantFiltrosConFecha = 0;
		//        //var cantFiltrosConCosto = 0;

		//        for (var j = 0; j < this.filtros.length; j++) {

		//            switch (obtenerIDTipoRegistro(this.filtros[j].elemento.key)) {
		//                case tipoRegistroConfig.SUJETO_PASIVO:
		//                case tipoRegistroConfig.AUDIENCIA:
		//                case tipoRegistroConfig.DONATIVO:
		//                case tipoRegistroConfig.SUJETO_ACTIVO:
		//                    cantFiltrosConFecha++;

		//                    break;
		//                case tipoRegistroConfig.VIAJE:
		//                    cantFiltrosConFecha++;
		//                    cantFiltrosConCosto++

		//                    break;
		//                default:
		//            }
		//        }

		//        //var indice = 0;

		//        //if (cantFiltrosConFecha <= 0) {
		//        //    indice = vm.filtros.map(function (e) { return e.seccion; }).indexOf('fechaDesde');

		//        //    if (indice >= 0) {
		//        //        vm.filtros.splice(indice, 1);
		//        //        vm.busqueda.FechaDesde = null;
		//        //    }

		//        //    indice = vm.filtros.map(function (e) { return e.seccion; }).indexOf('fechaHasta');

		//        //    if (indice >= 0) {
		//        //        vm.filtros.splice(indice, 1);
		//        //        vm.busqueda.FechaHasta = null;
		//        //    }
		//        //}

		//        //if (cantFiltrosConCosto <= 0) {
		//        //    indice = vm.filtros.map(function (e) { return e.seccion; }).indexOf('costoDesde');

		//        //    if (indice >= 0) {
		//        //        vm.filtros.splice(indice, 1);
		//        //        vm.busqueda.CostoDesde = null;
		//        //    }

		//        //    indice = vm.filtros.map(function (e) { return e.seccion; }).indexOf('costoHasta');

		//        //    if (indice >= 0) {
		//        //        vm.filtros.splice(indice, 1);
		//        //        vm.busqueda.CostoHasta = null;
		//        //    }
		//        //}

		//        /* Oculta filtros en modo mobile */
		//        vm.esFiltroMobileContraido = true;                    

		/* Vuelve a ejecutar búsqueda */
		this._realizarBusqueda();

		return;
		//}
		//}
	}

	limpiarFiltro(seccion, elemento) {
		//console.info(seccion);
		//console.info(elemento);
		switch (seccion) {
			case 'organismo':
				this._desmarcarFiltro(elemento.key, this.modelo.ResultadoBusqueda.Organismos);

				break;
			case 'cargo':
				this._desmarcarFiltro(elemento.key, this.modelo.ResultadoBusqueda.Cargos);

				break;
			case 'tipoRegistro':
				this._desmarcarFiltro(elemento.key, this.modelo.ResultadoBusqueda.TiposRegistro);

				break;
			//case 'autor':
			//	this._desmarcarFiltro(elemento.key, this.modelo.ResultadoBusqueda.Caso);

			//	break;
		}
	}

	limpiarResultados() {

		this.modelo.ResultadoBusqueda.Facetas.CantAudiencia = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantAudienciaStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivoStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantDonativo = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantDonativoStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantViaje = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantViajeStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivoStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantRepresentado = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantRepresentadoStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantCaso = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantCasoStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompraStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantLicitacion = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantLicitacionStr = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantProveedor = 0;
		this.modelo.ResultadoBusqueda.Facetas.CantProveedorStr = 0;

		this.modelo.ResultadoBusqueda.TotalEncontrados = 0;
		this.modelo.ResultadoBusqueda.TotalEncontradosStr = 0;

		this.modelo.ResultadoBusqueda.Documentos = [];

		this.totalOcurrencias = 0;
	}

	sugerir(textoBusqueda) {
		if (this.utilFactory.isNullOrEmpty(textoBusqueda) || textoBusqueda.length < this.sugerenciaConfig.MINIMO_CARACTERES) return;

		return this.buscadorService
			.sugerir({
				TextoBusqueda: textoBusqueda
			},
				function (response) {
					/** La directiva uib-typeahead funciona con return en el sevicio y no con la llamada a la función success() */
				},
				function (response) {
					this.$log.log(response.statusText);
				}
			);
	}

	configurarBusqueda(tipoBusqueda) {
		//console.warn(tipoBusqueda);
		/* Establece filtro activo */
		this.filtroActivo.Todos = tipoBusqueda === this.tipoBusquedaConfig.TODOS;
		this.filtroActivo.SujetoActivo = tipoBusqueda === this.tipoBusquedaConfig.SUJETO_ACTIVO;
		this.filtroActivo.Representado = tipoBusqueda === this.tipoBusquedaConfig.REPRESENTADO;
		this.filtroActivo.Audiencia = tipoBusqueda === this.tipoBusquedaConfig.AUDIENCIA;
		this.filtroActivo.SujetoPasivo = tipoBusqueda === this.tipoBusquedaConfig.SUJETO_PASIVO;
		this.filtroActivo.Viaje = tipoBusqueda === this.tipoBusquedaConfig.VIAJE;
		this.filtroActivo.Donativo = tipoBusqueda === this.tipoBusquedaConfig.DONATIVO;
		this.filtroActivo.Materia = tipoBusqueda === this.tipoBusquedaConfig.MATERIA;
		this.filtroActivo.Destino = tipoBusqueda === this.tipoBusquedaConfig.DESTINO;
		this.filtroActivo.Singularizacion = tipoBusqueda === this.tipoBusquedaConfig.SINGULARIZACION;
		this.filtroActivo.Organismo = tipoBusqueda === this.tipoBusquedaConfig.ORGANISMO;
		this.filtroActivo.Caso = tipoBusqueda === this.tipoBusquedaConfig.CASO;
		this.filtroActivo.OrdenCompra = tipoBusqueda === this.tipoBusquedaConfig.ORDENCOMPRA;
		this.filtroActivo.Licitacion = tipoBusqueda === this.tipoBusquedaConfig.LICITACION;
		this.filtroActivo.Proveedor = tipoBusqueda === this.tipoBusquedaConfig.PROVEEDOR;

		/* Genera faceta y define texto de botón ver */
		var facetas = '';
		var camposBusqueda = [];

		switch (tipoBusqueda) {
			case this.tipoBusquedaConfig.TODOS:
				this.descBotonResultados = 'Todos';

				break;
			case this.tipoBusquedaConfig.ORGANISMO:
				this.descBotonResultados = 'Organismo';
				facetas = '{"tipoRegistro": "Organismo"}';

				break;
			case this.tipoBusquedaConfig.SUJETO_ACTIVO:
				this.descBotonResultados = 'Sujeto Activo';
				facetas = '{"tipoRegistro": "Sujeto-Activo"}';

				break;
			case this.tipoBusquedaConfig.CASO:
				this.descBotonResultados = 'Caso';
				facetas = '{"tipoRegistro": "Caso"}';

				break;
			case this.tipoBusquedaConfig.ORDENCOMPRA:
				this.descBotonResultados = 'OrdenCompra';
				facetas = '{"tipoRegistro": "OrdenCompra"}';

				break;
			case this.tipoBusquedaConfig.LICITACION:
				this.descBotonResultados = 'Licitacion';
				facetas = '{"tipoRegistro": "Licitacion"}';

				break;
			case this.tipoBusquedaConfig.SUJETO_PASIVO:
				this.descBotonResultados = 'Funcionario';
				facetas = '{"tipoRegistro": "Funcionario"}';

				break;
			case this.tipoBusquedaConfig.PROVEEDOR:
				this.descBotonResultados = 'Proveedor';
				facetas = '{"tipoRegistro": "Proveedor"}';

				break;
			//case this.tipoBusquedaConfig.MATERIA:
			//    this.descBotonResultados = 'Materia';
			//    facetas = '{"tipoRegistro": "Audiencia"}';
			//    camposBusqueda.push({ TipoRegistro: this.tipoRegistroConfig.AUDIENCIA, CampoBusqueda: this.campoBusquedaConfig.MATERIA });
			//    break;
			default:
				this.descBotonResultados = 'Todos';

				break;
		}
		if (facetas.length > 0)
			facetas = '{"facetas": [' + facetas + ']}';

		this.modelo.Busqueda.Facetas = facetas;
		this.modelo.Busqueda.CamposBusqueda = JSON.stringify(camposBusqueda);

		this.buscar();
	}

	buscar() {
		this._realizarBusquedaHome2();
	}

	buscarHome(busquedaExacta) {

		if (this.utilFactory.isNullOrEmpty(busquedaExacta) || busquedaExacta.length < this.sugerenciaConfig.MINIMO_CARACTERES) {
			this.limpiarResultados();
			this.mostrarSugerencia = false;
			return;
		}

		this.mostrarSugerencia = true;
		/** Limpia modelo de resultados */
		this.filtros = [];

		// this.modelo.ResultadoBusqueda.Documentos = [];
		this.modelo.ResultadoBusqueda.Destacados = [];
		this.modelo.ResultadoBusqueda.Organismos = [];
		this.modelo.ResultadoBusqueda.Cargos = [];
		this.modelo.ResultadoBusqueda.TiposRegistro = [];
		this.modelo.ResultadoBusqueda.Regiones = [];

		this.modelo.Busqueda.TextoBusqueda = busquedaExacta;
		//console.info('aqui: ' + busquedaExacta);
		if (!busquedaExacta)
			this.modelo.Busqueda.Nombre = null;

		this.modelo.Busqueda.FechaDesde = null;
		this.modelo.Busqueda.FechaHasta = null;
		this.modelo.Busqueda.CostoDesde = null;
		this.modelo.Busqueda.CostoHasta = null;

		/** Ejecuta búsqueda base */
		this._realizarBusquedaHome();
	}

	buscarRedirect(busquedaExacta) {
		/** Limpia modelo de resultados */
		this.modelo.ResultadoBusqueda.Destacados = [];
		this.modelo.ResultadoBusqueda.Organismos = [];
		this.modelo.ResultadoBusqueda.Cargos = [];
		this.modelo.ResultadoBusqueda.TiposRegistro = [];
		this.modelo.ResultadoBusqueda.Regiones = [];

		this.modelo.Busqueda.TextoBusqueda = busquedaExacta;
		//this.modelo.Busqueda.BusquedaExacta = busquedaExacta;

		if (!busquedaExacta)
			this.modelo.Busqueda.Nombre = null;

		this.modelo.Busqueda.FechaDesde = null;
		this.modelo.Busqueda.FechaHasta = null;
		this.modelo.Busqueda.CostoDesde = null;
		this.modelo.Busqueda.CostoHasta = null;

		/** Ejecuta búsqueda base */
		this._realizarBusquedaRedirect();
	}

	paginar() {

		this._realizarBusqueda();
	}

	ordenar(descendente) {

		this._realizarBusqueda();
	}

	obtenerTextoDinamico(id) {

		var destacados = this.modelo.ResultadoBusqueda.Destacados;

		for (var d in destacados) {
			if (destacados[d].ID == id)
				return this.$sce.trustAsHtml(destacados[d].valor);
		}

		return null;
	}

	obtenerTextoFecha(documento) {

		var textoFecha = 'TextoFecha';

		return textoFecha;
	}

	exportar(formato) {

		this.buscadorService
			.exportar({
				IDBusqueda: this.$stateParams.idBusqueda,
				Formato: formato
			},
				(response) => {
					this.utilFactory.descargarBase64(response.data);
				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_parJson(json) {
		return JSON.parse(json);
	}

	_realizarBusqueda() {

		var facetassel = this.obtenerFacetas();

		for (var i = 0; i < facetassel.facetas.length; i++) {

			var keyI = Object.keys(facetassel.facetas[i])[0];
			var existe = false;

			for (var j = 0; j < this._facetasSeleccionadas.facetas.length; j++) {

				var keyJ = Object.keys(this._facetasSeleccionadas.facetas[j])[0];

				if (keyJ === keyI && this._facetasSeleccionadas.facetas[j][keyJ] === facetassel.facetas[i][keyI])
					existe = true;

				if (existe) break;
			}

			if (!existe)
				this._facetasSeleccionadas.facetas.push(JSON.parse('{"' + keyI + '": "' + facetassel.facetas[i][keyI] + '"}'));
		}
		/*Obtiene los campos de búsqueda que se están utilizando para filtrar */
		this.camposBusqueda = this.obtenerCamposBusqueda();

		var cantFiltrosConFecha = 0;
		var cantFiltrosConCosto = 0;

		for (var i in this.modelo.ResultadoBusqueda.TiposRegistro) {
			if (this.modelo.ResultadoBusqueda.TiposRegistro[i].Estado) {

				switch (this.obtenerIDTipoRegistro(this.modelo.ResultadoBusqueda.TiposRegistro[i].key)) {
					case this.tipoRegistroConfig.SUJETO_PASIVO:
					case this.tipoRegistroConfig.ORGANISMO:
					case this.tipoRegistroConfig.DONATIVO:
					case this.tipoRegistroConfig.SUJETO_ACTIVO:
					case this.tipoRegistroConfig.CASO:
					case this.tipoRegistroConfig.ORDENCOMPRA:
					case this.tipoRegistroConfig.LICITACION:
					case this.tipoRegistroConfig.PROVEEDOR:
						cantFiltrosConFecha++;

						break;
					case this.tipoRegistroConfig.VIAJE:

						cantFiltrosConFecha++;
						cantFiltrosConCosto++

						break;
					default:
				}
			}
		}

		/** Si no hay filtros que utilcen fecha o costo, se limpian los campos de la pantalla */
		if (cantFiltrosConFecha <= 0) {
			this.modelo.Busqueda.FechaDesde = null;
			this.modelo.Busqueda.FechaHasta = null;
		}

		if (cantFiltrosConCosto <= 0) {
			this.modelo.Busqueda.CostoDesde = null;
			this.modelo.Busqueda.CostoHasta = null;
		}

		this.buscadorService
			.crear({
				TextoBusqueda: this.modelo.ResultadoBusqueda.Busqueda.TextoBusqueda,
				BusquedaExacta: this.modelo.Busqueda.BusquedaExacta,
				Facetas: JSON.stringify(this._facetasSeleccionadas),
				FechaDesde: this.modelo.Busqueda.FechaDesde ? this.utilFactory.convertirFecha(this.modelo.Busqueda.FechaDesde) : null,
				FechaHasta: this.modelo.Busqueda.FechaHasta ? this.utilFactory.convertirFecha(this.modelo.Busqueda.FechaHasta) : null,
				CostoDesde: this.modelo.Busqueda.CostoDesde ? this.utilFactory.convertirNumero(this.modelo.Busqueda.CostoDesde) : null,
				CostoHasta: this.modelo.Busqueda.CostoHasta ? this.utilFactory.convertirNumero(this.modelo.Busqueda.CostoHasta) : null,
				Nombre: this.modelo.ResultadoBusqueda.Busqueda.Nombre,
				CampoBusqueda: this.camposBusqueda,
				Pagina: this.modelo.Busqueda.Pagina,
				Registros: this.modelo.Busqueda.Registros,
				Orden: this.orden[this.modelo.Busqueda.Orden - 1].campo,
				Descendente: this.orden[this.modelo.Busqueda.Orden - 1].descendente
			},
				(response) => {
					this._recargarAv(response.data);
					this.$stateParams['idBusqueda'] = response.data;
					this.$state.go('busqueda-avanzada', { idBusqueda: response.data }, { notify: false });
				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_realizarBusquedaHome() {

		var facetas = this._obtenerFacetas();

		this.buscadorService
			.crear({
				TextoBusqueda: this.modelo.Busqueda.TextoBusqueda,
				BusquedaExacta: this.modelo.Busqueda.BusquedaExacta,
				Facetas: facetas,
				FechaDesde: this.modelo.Busqueda.FechaDesde ? this.utilFactory.convertirFecha(this.modelo.Busqueda.FechaDesde) : null,
				FechaHasta: this.modelo.Busqueda.FechaHasta ? this.utilFactory.convertirFecha(this.modelo.Busqueda.FechaHasta) : null,
				CostoDesde: this.modelo.Busqueda.CostoDesde ? this.utilFactory.convertirNumero(this.modelo.Busqueda.CostoDesde) : null,
				CostoHasta: this.modelo.Busqueda.CostoHasta ? this.utilFactory.convertirNumero(this.modelo.Busqueda.CostoHasta) : null,
				Nombre: this.modelo.Busqueda.Nombre,
				Pagina: 1, //this.modelo.Busqueda.Pagina,
				Registros: 15, //this.modelo.Busqueda.Registros,
				Orden: this.orden[this.modelo.Busqueda.Orden - 1].campo,
				Descendente: this.orden[this.modelo.Busqueda.Orden - 1].descendente
			},
				(response) => {
					console.warn('Aqui llegue : ' + response.data);
					//window.location = "buscador-redirect?idBusqueda=" + response.data;
					this._recargaHome(response.data);
				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_realizarBusquedaHome2() {
		this.buscadorService
			.crear({
				TextoBusqueda: this.modelo.Busqueda.TextoBusqueda,
				BusquedaExacta: this.modelo.Busqueda.BusquedaExacta,
				Facetas: this.modelo.Busqueda.Facetas,
				CampoBusqueda: this.modelo.Busqueda.CamposBusqueda,
				Pagina: 1,
				Registros: 15,
				Orden: this.orden[this.modelo.Busqueda.Orden - 1].campo,
				Descendente: this.orden[this.modelo.Busqueda.Orden - 1].descendente
			},
				(response) => {
					console.warn('Home2 : ' + response.data);
					this._recargaHome2(response.data);
				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_realizarBusquedaRedirect() {

		var facetas = this._obtenerFacetas();

		this.buscadorService
			.crear({
				TextoBusqueda: this.modelo.Busqueda.TextoBusqueda,
				BusquedaExacta: this.modelo.Busqueda.BusquedaExacta,
				Facetas: this.facetas,
				FechaDesde: this.modelo.Busqueda.FechaDesde ? this.utilFactory.convertirFecha(this.modelo.Busqueda.FechaDesde) : null,
				FechaHasta: this.modelo.Busqueda.FechaHasta ? this.utilFactory.convertirFecha(this.modelo.Busqueda.FechaHasta) : null,
				CostoDesde: this.modelo.Busqueda.CostoDesde ? this.utilFactory.convertirNumero(this.modelo.Busqueda.CostoDesde) : null,
				CostoHasta: this.modelo.Busqueda.CostoHasta ? this.utilFactory.convertirNumero(this.modelo.Busqueda.CostoHasta) : null,
				Nombre: this.modelo.Busqueda.Nombre,
				Pagina: this.modelo.Busqueda.Pagina,
				Registros: this.modelo.Busqueda.Registros,
				Orden: this.orden[this.modelo.Busqueda.Orden - 1].campo,
				Descendente: this.orden[this.modelo.Busqueda.Orden - 1].descendente
			},
				(response) => {
					console.warn('click : ' + response.data);
					window.location = "buscador-redirect?idBusqueda=" + response.data;
				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_limpiarFiltro(filtro) {


		switch (filtro.seccion) {
			case 'organismo':
				this._desmarcarFiltro(filtro.elemento.key, this.modelo.ResultadoBusqueda.Organismos);

				break;
			case 'cargo':
				this._desmarcarFiltro(filtro.elemento.key, this.modelo.ResultadoBusqueda.Cargos);

				break;
			case 'tipoRegistro':
				this._desmarcarFiltro(filtro.elemento.key, this.modelo.ResultadoBusqueda.TiposRegistro);

				break;
			case 'autor':
				this._desmarcarFiltro(filtro.elemento.key, this.modelo.ResultadoBusqueda.Caso);

				break;
		}
	}

	_desmarcarFiltro(key, coleccion) {

		for (var i in coleccion) {
			if (coleccion[i].key == key)
				coleccion[i].Estado = false;
		}
	}

	_obtenerFacetas() {
		var facetas = '';
		facetas += this._generarFiltroFaceta('funcionario', this.modelo.ResultadoBusqueda.Funcionarios);
		facetas += this._generarFiltroFaceta('organismo', this.modelo.ResultadoBusqueda.Organismos);
		facetas += this._generarFiltroFaceta('cargo', this.modelo.ResultadoBusqueda.Cargos);
		//facetas += this._generarFiltroFaceta('cargo', this.modelo.ResultadoBusqueda.Cargos);
		//facetas += this._generarFiltroFaceta('autor', this.modelo.ResultadoBusqueda.Autores);


		if (facetas.length > 0) {
			facetas = facetas.replace(/}{/g, '},{');
			facetas = '{"facetas": [' + facetas + ']}';
		}
		this.$log.log(facetas);
		return facetas;
	}

	obtenerFacetas() {
		var facetas = [];
		var coleccion = [];

		/** Faceta Organismo */
		coleccion = this._generarFiltroFaceta('organismo', this.modelo.ResultadoBusqueda.Organismos);
		if (coleccion.length > 0) coleccion.forEach(function (e) { facetas.push(e) });

		/** Faceta Cargo */
		coleccion = this._generarFiltroFaceta('cargo', this.modelo.ResultadoBusqueda.Cargos);
		if (coleccion.length > 0) coleccion.forEach(function (e) { facetas.push(e) });

		/** Faceta Tipo de Declaración */
		coleccion = this._generarFiltroFaceta('tipoRegistro', this.modelo.ResultadoBusqueda.TiposRegistro)
		if (coleccion.length > 0) coleccion.forEach(function (e) { facetas.push(e) });

		/** Faceta Región */
		//coleccion = this._generarFiltroFaceta('region', vm.resultadoBusqueda.Regiones);
		//if (coleccion.length > 0) coleccion.forEach(function (e) { facetas.push(e) });

		return { facetas: facetas };
	}

	_generarFiltroFaceta(categoria, coleccion) {
		var facetas = [];

		for (var i in coleccion) {
			if (coleccion[i].Estado)
				facetas.push(JSON.parse('{"' + categoria + '": "' + coleccion[i].key + '"}'));
		}

		return facetas;
	}

	_marcarFacetaFiltrada(filtro) {

		if (!filtro) return;

		var resultado = this._parJson(filtro);


		for (var i = 0; i < resultado.facetas.length; i++) {
			for (var key in resultado.facetas[i]) {
				switch (key) {
					case 'organismo':
						this._asignarEstado(this.modelo.ResultadoBusqueda.Organismos, resultado.facetas[i][key]);

						break;
					case 'tipoRegistro':
						this._asignarEstado(this.modelo.ResultadoBusqueda.TiposRegistro, resultado.facetas[i][key]);

						break;
					case 'cargo':
						this._asignarEstado(this.modelo.ResultadoBusqueda.Cargos, resultado.facetas[i][key]);

						break;
					//case 'autor':
					//	this._asignarEstado(this.modelo.ResultadoBusqueda.Autores, resultado.facetas[i][key]);

					//	break;
				}
			}

		}
	}

	_asignarEstado(coleccion, valor) {

		for (var i = 0; i < coleccion.length; i++) {

			for (var key in coleccion[i]) {

				if (coleccion[i][key] == valor) {

					coleccion[i].Estado = true;

					return;
				}
			}
		}
	}

	_recargaHome(idBusqueda) {
		this.buscadorService
			.recargar({
				idBusqueda: idBusqueda
			},
				(response) => {
					if (response.data.busqueda.busquedaExacta && response.data.documentos.length === 0) {
						this.utilFactory.mostrarMensaje('No se encontraron documentos');
					}
					//console.info(response.data);
					this.modelo.ResultadoBusqueda.Documentos = response.data.documentos;
					this.modelo.ResultadoBusqueda.TotalEncontrados = response.data.totalEncontrados;
					this.modelo.ResultadoBusqueda.Destacados = response.data.destacados;
					this.modelo.ResultadoBusqueda.Busqueda = response.data.busqueda;
					this.modelo.ResultadoBusqueda.Organismos = response.data.facetas['organismo'];
					this.modelo.ResultadoBusqueda.Cargos = response.data.facetas['cargo'];
					this.modelo.ResultadoBusqueda.TiposRegistro = response.data.facetas['tipoRegistro'];
					//this.modelo.ResultadoBusqueda.Autores = response.data.facetas['autor'];


					/** Recarga todos los datos utilizados en su momento para realizar búsqueda */
					this.modelo.ResultadoBusqueda.Busqueda.TextoBusqueda = response.data.busqueda.textoBusqueda;
					this.modelo.ResultadoBusqueda.Busqueda.BusquedaExacta = response.data.busqueda.busquedaExacta;
					//  this.modelo.Busqueda.Nombre = response.data.busqueda.nombre;

					this._marcarFacetaFiltrada(response.data.busqueda.facetas);

					//this.modelo.Busqueda.FechaDesde = response.data.busqueda.fechaDesde ? this.utilFactory.formatearFecha(response.data.busqueda.fechaDesde) : null;
					//this.modelo.Busqueda.FechaHasta = response.data.busqueda.fechaHasta ? this.utilFactory.formatearFecha(response.data.busqueda.fechaHasta) : null;

					if (response.data.facetas.tipoRegistro) {
						var indice = -1;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Funcionario');
						this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivoStr = this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Organismo');
						this.modelo.ResultadoBusqueda.Facetas.CantOrganismo = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantOrganismoStr = this.modelo.ResultadoBusqueda.Facetas.CantOrganismo > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantOrganismo;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Caso');
						this.modelo.ResultadoBusqueda.Facetas.CantCaso = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantCasoStr = this.modelo.ResultadoBusqueda.Facetas.CantCaso > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantCaso;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('OrdenCompra');
						this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompraStr = this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Licitacion');
						this.modelo.ResultadoBusqueda.Facetas.CantLicitacion = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantLicitacionStr = this.modelo.ResultadoBusqueda.Facetas.CantLicitacion > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantLicitacion;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Sujeto-Activo');
						this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivoStr = this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Representado');
						this.modelo.ResultadoBusqueda.Facetas.CantRepresentado = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantRepresentadoStr = this.modelo.ResultadoBusqueda.Facetas.CantRepresentado > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantRepresentado;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Audiencia');
						this.modelo.ResultadoBusqueda.Facetas.CantAudiencia = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantAudienciaStr = this.modelo.ResultadoBusqueda.Facetas.CantAudiencia > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantAudiencia;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Proveedor');
						this.modelo.ResultadoBusqueda.Facetas.CantProveedor = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantProveedorStr = this.modelo.ResultadoBusqueda.Facetas.CantProveedor > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantProveedor;
					}
					this.modelo.ResultadoBusqueda.TotalEncontrados = this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo + this.modelo.ResultadoBusqueda.Facetas.CantAudiencia + this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo +
						this.modelo.ResultadoBusqueda.Facetas.CantRepresentado + this.modelo.ResultadoBusqueda.Facetas.CantCaso + this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra + this.modelo.ResultadoBusqueda.Facetas.CantLicitacion
						+ this.modelo.ResultadoBusqueda.Facetas.CantProveedor;

					this.modelo.ResultadoBusqueda.TotalEncontradosStr = this.modelo.ResultadoBusqueda.TotalEncontrados > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.TotalEncontrados;

					this.modelo.ResultadoBusqueda.Documentos = response.data.documentos;

					if (this.filtroActivo.Todos)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.TotalEncontrados;
					else if (this.filtroActivo.SujetoActivo)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo;
					else if (this.filtroActivo.Representado)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantRepresentado;
					else if (this.filtroActivo.Audiencia)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantAudiencia;
					else if (this.filtroActivo.SujetoPasivo)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo;
					else if (this.filtroActivo.Viaje)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantViaje;
					else if (this.filtroActivo.Donativo)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantDonativo;
					else if (this.filtroActivo.Materia)
						this.totalOcurrencias = response.data.TotalEncontrados;
					else if (this.filtroActivo.Destino)
						this.totalOcurrencias = response.data.TotalEncontrados;
					else if (this.filtroActivo.Singularizacion)
						this.totalOcurrencias = response.data.TotalEncontrados;
					else if (this.filtroActivo.Organismo)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantOrganismo;
					else if (this.filtroActivo.Caso)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantCaso;
					else if (this.filtroActivo.OrdenCompra)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra;
					else if (this.filtroActivo.Licitacion)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantLicitacion;
					else if (this.filtroActivo.Proveedor)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantProveedor;
					else
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.TotalEncontrados;
					this._cargarFiltrosSeleccionados();

					this.modelo.Busqueda.Orden = this._obtenerIDOrden(response.data.busqueda.orden, response.data.busqueda.descendente);

					console.log(this.modelo);
				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_recargaHome2(idBusqueda) {
		this.buscadorService
			.recargar({
				idBusqueda: idBusqueda
			},
				(response) => {

					var cantMax = 99;
					var cantMaxStr = '99+';
					this.limpiarResultados();

					if (response.data.facetas.tipoRegistro) {
						var indice = -1;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Funcionario');
						this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivoStr = this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Organismo');
						this.modelo.ResultadoBusqueda.Facetas.CantOrganismo = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantOrganismoStr = this.modelo.ResultadoBusqueda.Facetas.CantOrganismo > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantOrganismo;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Sujeto-Activo');
						this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivoStr = this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Caso');
						this.modelo.ResultadoBusqueda.Facetas.CantCaso = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantCasoStr = this.modelo.ResultadoBusqueda.Facetas.CantCaso > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantCaso;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('OrdenCompra');
						this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompraStr = this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Licitacion');
						this.modelo.ResultadoBusqueda.Facetas.CantLicitacion = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantLicitacionStr = this.modelo.ResultadoBusqueda.Facetas.CantLicitacion > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantLicitacion;

						indice = response.data.facetas.tipoRegistro.map(function (e) { return e.key }).indexOf('Proveedor');
						this.modelo.ResultadoBusqueda.Facetas.CantProveedor = indice >= 0 ? response.data.facetas.tipoRegistro[indice].value : 0;
						this.modelo.ResultadoBusqueda.Facetas.CantProveedorStr = this.modelo.ResultadoBusqueda.Facetas.CantProveedor > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.Facetas.CantProveedor;

						//indice = response.data.Facetas.tipoRegistro.map(function (e) { return e.Key }).indexOf('Representado');
						//this.resultadoBusqueda.Facetas.CantRepresentado = indice >= 0 ? response.data.Facetas.tipoRegistro[indice].Value : 0;
						//this.resultadoBusqueda.Facetas.CantRepresentadoStr = this.resultadoBusqueda.Facetas.CantRepresentado > cantMax ? cantMaxStr : this.resultadoBusqueda.Facetas.CantRepresentado;
					}
					this.modelo.ResultadoBusqueda.TotalEncontrados = this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo + this.modelo.ResultadoBusqueda.Facetas.CantAudiencia + this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo
						+ this.modelo.ResultadoBusqueda.Facetas.CantRepresentado + this.modelo.ResultadoBusqueda.Facetas.CantCaso + this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra + this.modelo.ResultadoBusqueda.Facetas.CantLicitacion
						+ this.modelo.ResultadoBusqueda.Facetas.CantProveedor;

					this.modelo.ResultadoBusqueda.TotalEncontradosStr = this.modelo.ResultadoBusqueda.TotalEncontrados > this.cantMax ? this.cantMaxStr : this.modelo.ResultadoBusqueda.TotalEncontrados;

					this.modelo.ResultadoBusqueda.Documentos = response.data.documentos;

					if (this.filtroActivo.Todos)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.TotalEncontrados;
					else if (this.filtroActivo.SujetoActivo)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantSujetoActivo;
					else if (this.filtroActivo.Representado)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantRepresentado;
					else if (this.filtroActivo.Audiencia)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantAudiencia;
					else if (this.filtroActivo.SujetoPasivo)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantSujetoPasivo;
					else if (this.filtroActivo.Viaje)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantViaje;
					else if (this.filtroActivo.Donativo)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantDonativo;
					else if (this.filtroActivo.Materia)
						this.totalOcurrencias = response.data.TotalEncontrados;
					else if (this.filtroActivo.Destino)
						this.totalOcurrencias = response.data.TotalEncontrados;
					else if (this.filtroActivo.Singularizacion)
						this.totalOcurrencias = response.data.TotalEncontrados;
					else if (this.filtroActivo.Organismo)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantOrganismo;
					else if (this.filtroActivo.Caso)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantCaso;
					else if (this.filtroActivo.OrdenCompra)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantOrdenCompra;
					else if (this.filtroActivo.Licitacion)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantLicitacion;
					else if (this.filtroActivo.Proveedor)
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.Facetas.CantProveedor;
					else
						this.totalOcurrencias = this.modelo.ResultadoBusqueda.TotalEncontrados;

					this.modelo.Busqueda.Orden = this._obtenerIDOrden(response.data.busqueda.orden, response.data.busqueda.descendente);

					console.log(this.modelo);
				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_recargar(idBusqueda) {
		this.buscadorService
			.recargar({
				idBusqueda: idBusqueda
			},
				(response) => {
					if (response.data.busqueda.busquedaExacta && response.data.documentos.length === 0) {
						this.utilFactory.mostrarMensaje('No se encontraron documentos');
					}

					this.modelo.ResultadoBusqueda.Documentos = response.data.documentos;
					this.modelo.ResultadoBusqueda.TotalEncontrados = response.data.totalEncontrados;
					this.modelo.ResultadoBusqueda.Destacados = response.data.destacados;
					this.modelo.ResultadoBusqueda.Busqueda = response.data.busqueda;
					this.modelo.ResultadoBusqueda.Organismos = response.data.facetas['organismo'];
					this.modelo.ResultadoBusqueda.TiposRegistro = response.data.facetas['tipoRegistro'];
					this.modelo.ResultadoBusqueda.Cargos = response.data.facetas['cargo'];
					//this.modelo.ResultadoBusqueda.Autores = response.data.facetas['autor'];


					/** Recarga todos los datos utilizados en su momento para realizar búsqueda */
					this.modelo.ResultadoBusqueda.Busqueda.TextoBusqueda = response.data.busqueda.textoBusqueda;
					this.modelo.ResultadoBusqueda.Busqueda.BusquedaExacta = response.data.busqueda.busquedaExacta;
					//  this.modelo.Busqueda.Nombre = response.data.busqueda.nombre;

					this._marcarFacetaFiltrada(response.data.busqueda.facetas);

					this.modelo.Busqueda.FechaDesde = response.data.busqueda.fechaDesde ? this.utilFactory.formatearFecha(response.data.busqueda.fechaDesde) : null;
					this.modelo.Busqueda.FechaHasta = response.data.busqueda.fechaHasta ? this.utilFactory.formatearFecha(response.data.busqueda.fechaHasta) : null;

					//console.info('modelo:');
					//console.info(this.modelo);

					this._cargarFiltrosSeleccionados();

					this.modelo.Busqueda.Orden = this._obtenerIDOrden(response.data.busqueda.orden, response.data.busqueda.descendente);
				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_recargarAv(idBusqueda) {
		this.buscadorService
			.recargar({
				idBusqueda: idBusqueda
			},
				(response) => {
					console.info(response.data);

					this.modelo.ResultadoBusqueda.Documentos = response.data.documentos;
					this.modelo.ResultadoBusqueda.TotalEncontrados = response.data.totalEncontrados;
					this.modelo.ResultadoBusqueda.Destacados = response.data.destacados;
					this.modelo.ResultadoBusqueda.Busqueda = response.data.busqueda;
					this.modelo.ResultadoBusqueda.Organismos = response.data.facetas['organismo'];
					this.modelo.ResultadoBusqueda.TiposRegistro = response.data.facetas['tipoRegistro'];
					this.modelo.ResultadoBusqueda.Cargos = response.data.facetas['cargo'];
					//this.modelo.ResultadoBusqueda.Autores = response.data.facetas['autor'];


					/** Recarga todos los datos utilizados en su momento para realizar búsqueda */
					this.modelo.ResultadoBusqueda.Busqueda.TextoBusqueda = response.data.busqueda.textoBusqueda;
					this.modelo.ResultadoBusqueda.Busqueda.BusquedaExacta = response.data.busqueda.busquedaExacta;
					//  this.modelo.Busqueda.Nombre = response.data.busqueda.nombre;

					this._marcarFacetaFiltrada(response.data.busqueda.facetas);

					//this.modelo.Busqueda.FechaDesde = response.data.busqueda.fechaDesde ? this.utilFactory.formatearFecha(response.data.busqueda.fechaDesde) : null;
					//this.modelo.Busqueda.FechaHasta = response.data.busqueda.fechaHasta ? this.utilFactory.formatearFecha(response.data.busqueda.fechaHasta) : null;

					/** Genera colección de filtros total considerando facetas, campos de búsqueda específicos y campos especiales como fecha y costo */
					//console.info('modelo:');
					//console.info(this.modelo);
					this._cargarFiltrosSeleccionados();
					//this.cargarFiltrosSeleccionados(response.data.busqueda.CamposBusqueda);
					//this._cargarFiltrosSeleccionados();

					/** Establece orden para el despliegue de los datos */
					this.modelo.Busqueda.Orden = this._obtenerIDOrden(response.data.busqueda.orden, response.data.busqueda.descendente);

				},
				(response) => {
					this.$log.log(response.statusText);
				});
	}

	_cargarFiltrosSeleccionados() {

		this.filtros = [];

		for (var i in this.modelo.ResultadoBusqueda.Organismos) {
			if (this.modelo.ResultadoBusqueda.Organismos[i].Estado)
				this._actualizarFiltro('organismo', this.modelo.ResultadoBusqueda.Organismos[i]);
		}

		for (var i in this.modelo.ResultadoBusqueda.Cargos) {
			if (this.modelo.ResultadoBusqueda.Cargos[i].Estado)
				this._actualizarFiltro('cargo', this.modelo.ResultadoBusqueda.Cargos[i]);
		}

		for (var i in this.modelo.ResultadoBusqueda.TiposRegistro) {
			if (this.modelo.ResultadoBusqueda.TiposRegistro[i].Estado)
				this._actualizarFiltro('tipoRegistro', this.modelo.ResultadoBusqueda.TiposRegistro[i]);
		}

		//for (var i in this.modelo.ResultadoBusqueda.Autores) {
		//    if (this.modelo.ResultadoBusqueda.Autores[i].Estado)
		//        this._actualizarFiltro('autor', this.modelo.ResultadoBusqueda.Autores[i]);
		//}



	}

	_actualizarFiltro(seccion, elemento) {

		this.filtros.push({ seccion: seccion, elemento: elemento });
	}

	_obtenerIDOrden(campo, descendente) {

		for (var i in this.orden) {

			if (this.orden[i].campo == campo && this.orden[i].descendente == descendente) {

				return this.utilFactory.convertirNumero(i) + 1;
			}
		}
	}

	_cambiarUbicacion(url) {
		window.location.href = url;
	}

	cargarFicha($item, $model, $label, $event) {

		this.modelo.Busqueda.TextoBusqueda = this.TextoBusquedaRespaldo;

		console.log(this.modelo.Busqueda.TextoBusqueda);
		if ($event && $event.keyCode == 13) {


		}
		else {

			//  this.modelo.Busqueda.TextoBusqueda = $item.payload;
			this.modelo.Busqueda.Nombre = $item.payload;//this.modelo.Busqueda.TextoBusqueda;

			this.buscar(true);
		}
	}
	cargarFichaRedirect($item, $model, $label, $event) {

		this.modelo.Busqueda.TextoBusqueda = this.TextoBusquedaRespaldo;

		console.log(this.modelo.Busqueda.TextoBusqueda);
		if ($event && $event.keyCode == 13) {


		}
		else {

			//  this.modelo.Busqueda.TextoBusqueda = $item.payload;
			this.modelo.Busqueda.Nombre = $item.payload;//this.modelo.Busqueda.TextoBusqueda;

			this.buscarRedirect(true);
		}
	}

	verMasFaceta(faceta) {

		switch (faceta) {
			case 'organismo':
				this.limiteOrganismo += this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;

				break;
			case 'tipoRegistro':
				this.limiteTipoRegistro += this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;

				break;
			case 'cargo':
				this.limiteCargo += this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;

				break;
			case 'autor':
				this.limiteAutores += this.paginacionConfig.CANTIDAD_REGISTROS_FACETA;

				break;
		}
	}

	cargarFichaResultado(documento) {
		if (!this.utilFactory.isNullOrEmpty(documento.Url)) {
			this._cambiarUbicacion(documento.Url);
		}
	}

	getQueryStringValue(key) {
		return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
	}

	$onChanges(changes) {
		console.log(changes);
	}

	$onInit() {
		this.TextoBusquedaRespaldo;
		this.moment.locale('es');

		this.$scope.$watch(() => { return this.modelo.Busqueda.TextoBusqueda }, (data) => {

			this.TextoBusquedaRespaldo = data;
		});

		var id = this.getQueryStringValue("idBusqueda");

		if (id) {
			this._recargar(id);
		}
	}

	/*AQUI CAMBIO DE FILTROS*/
	cargarFiltrosSeleccionados(camposBusqueda) {

		this.filtros = [];
		this.camposBusqueda = JSON.parse(camposBusqueda);

		//this.desplegarFiltroEspecial.FechaInicioTermino = false;
		//this.desplegarFiltroEspecial.Costo = false;

		for (var i = 0; i < _facetasSeleccionadas.facetas.length; i++) {

			/** Obtiene el nombre de la sección de filtros */
			var key = Object.keys(_facetasSeleccionadas.facetas[i])[0];

			/** Alimenta colección de filtros */
			this.filtros.push({ seccion: key, elemento: { Key: _facetasSeleccionadas.facetas[i][key] } });

			/** Para los filtros de la sección "Tipo de Registro", asigna los campos específicos para filtrar y determina si se debe desplegar filtro de fecha y costo */
			if (key === 'tipoRegistro') {

				/** Busca campo de búsqueda asociado al tipo de registro */
				var indice = camposBusqueda.map(function (e) {
					return e.TipoRegistro
				}).indexOf(obtenerIDTipoRegistro(_facetasSeleccionadas.facetas[i][key]));

				this.filtros[i].elemento.IDCampoBusqueda = indice >= 0 ? camposBusqueda[indice].CampoBusqueda : 0;

				/* Establece visualización de los filtros especiales */
				//switch (obtenerIDTipoRegistro(_facetasSeleccionadas.facetas[i][key])) {
				//    case tipoRegistroConfig.SUJETO_ACTIVO:
				//    case tipoRegistroConfig.SUJETO_PASIVO:
				//    case tipoRegistroConfig.DONATIVO:
				//    case tipoRegistroConfig.AUDIENCIA:
				//        this.desplegarFiltroEspecial.FechaInicioTermino = true;

				//        break;
				//    case tipoRegistroConfig.VIAJE:
				//        this.desplegarFiltroEspecial.FechaInicioTermino = true;
				//        this.desplegarFiltroEspecial.Costo = true;

				//        break;
				//    case tipoRegistroConfig.REPRESENTADO:

				//        break;
				//    default:
				//        this.desplegarFiltroEspecial.FechaInicioTermino = false;
				//        this.desplegarFiltroEspecial.Costo = false;
				//}
			}
		}

		/** Alimenta colección de filtros con fecha y costo según corresponda */
		//if (this.busqueda.CostoDesde)
		//    actualizarFiltro('costoDesde', { Key: filter('separadorMiles')(this.busqueda.CostoDesde) });

		//if (this.busqueda.CostoHasta)
		//    actualizarFiltro('costoHasta', { Key: filter('separadorMiles')(this.busqueda.CostoHasta) });

		//if (this.busqueda.FechaDesde)
		//    actualizarFiltro('fechaDesde', { Key: (this.busqueda.FechaDesde) });

		//if (this.busqueda.FechaHasta)
		//    actualizarFiltro('fechaHasta', { Key: (this.busqueda.FechaHasta) });            
	}

	obtenerCamposBusqueda() {

		this.camposBusqueda = [];

		angular.forEach(this.filtros, function (filtro) {

			if (filtro.seccion === 'tipoRegistro') {
				if (filtro.elemento.IDCampoBusqueda > 0) {

					var idTipoRegistro = this.obtenerIDTipoRegistro(filtro.elemento.key);

					this.camposBusqueda.push({ TipoRegistro: idTipoRegistro, CampoBusqueda: filtro.elemento.IDCampoBusqueda });
				}
			}
		});

		return JSON.stringify(this.camposBusqueda);
	}

	cargarPortada() {

		window.location.href = this.urlConfig.VIRTUAL_DIR;
	}

	obtenerIDTipoRegistro(tipoRegistro) {

		switch (tipoRegistro) {
			case 'Sujeto-Activo':
				return this.tipoRegistroConfig.SUJETO_ACTIVO;
			case 'Representado':
				return this.tipoRegistroConfig.REPRESENTADO;
			case 'Funcionario':
				return this.tipoRegistroConfig.SUJETO_PASIVO;
			case 'Audiencia':
				return this.tipoRegistroConfig.AUDIENCIA;
			case 'Viaje':
				return this.tipoRegistroConfig.VIAJE;
			case 'Donativo':
				return this.tipoRegistroConfig.DONATIVO;
			case 'Organismo':
				return this.tipoRegistroConfig.ORGANISMO;
			case 'Caso':
				return this.tipoRegistroConfig.CASO;
			case 'OrdenCompra':
				return this.tipoRegistroConfig.ORDENCOMPRA;
			case 'Licitacion':
				return this.tipoRegistroConfig.LICITACION;
			case 'Proveedor':
				return this.tipoRegistroConfig.PROVEEDOR;
			default:
				return 0;
		}
	}

	filtrarCamposBusqueda(filtro) {
		var tipo = this.obtenerIDTipoRegistro(filtro.elemento.key);
		return function (campo) {
			//campo.ID = 0;
			//switch (tipo) {
			//	case this.tipoRegistroConfig.SUJETO_PASIVO:
			//		return this.camposBusquedaSegmentados.SujetoPasivo.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	case this.tipoRegistroConfig.AUDIENCIA:
			//		return this.camposBusquedaSegmentados.Audiencia.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	case this.tipoRegistroConfig.VIAJE:
			//		return this.camposBusquedaSegmentados.Viaje.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	case this.tipoRegistroConfig.DONATIVO:
			//		return this.camposBusquedaSegmentados.Donativo.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	case this.tipoRegistroConfig.SUJETO_ACTIVO:
			//		return this.camposBusquedaSegmentados.SujetoActivo.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	case this.tipoRegistroConfig.REPRESENTADO:
			//		return this.camposBusquedaSegmentados.Representado.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	case this.tipoRegistroConfig.CASO:
			//		return this.camposBusquedaSegmentados.Caso.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	case this.tipoRegistroConfig.ORDENCOMPRA:
			//		return this.camposBusquedaSegmentados.OrdenCompra.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	case this.tipoRegistroConfig.LICITACION:
			//		return this.camposBusquedaSegmentados.Licitacion.indexOf(campo.ID) >= 0 || campo.ID === 0;
			//	default:
			//}
		}
	}


}

const MODULE_NAME = 'buscador.componentes.buscador-avanzado.controller';

const ngModule = angular.module(MODULE_NAME, []);


ngModule.controller('buscadorController', BusquedaController);

export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/componentes/buscador-avanzado/buscador-avanzado.controller.js